import React from 'react';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { Tooltip } from '@mui/material';
import { SxProps } from '@mui/system'; // Import SxProps

interface StructuredWorkoutIconProps {
  fontSize?: "small" | "inherit" | "large" | "medium";
  tooltipTitle?: string;
  sx?: SxProps; // Add the sx prop to the interface
  color?: string; // Add the color prop
}

export const StructuredWorkoutIcon: React.FC<StructuredWorkoutIconProps> = ({
  fontSize = "small",
  tooltipTitle = "Структуроване тренування",
  sx, // Destructure sx prop
  color // Destructure color prop
}) => {
  return (
    <Tooltip title={tooltipTitle}>
      <div>
        <FactCheckOutlinedIcon fontSize={fontSize} sx={sx} style={{ color: color }} /> {/* Pass sx and color to the underlying MUI icon */}
      </div>
    </Tooltip>
  );
};
